export default __webpack_public_path__ + "assets/orgauth-authed.8da81796.png";